import { MARQUEE_ITEMS } from "@/data/content";

const Marquee = () => {
  const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className="relative overflow-hidden border-y border-white/5 bg-[#0D1220] py-5"
      aria-hidden="true"
    >
      <div className="animate-marquee flex w-max items-center">
        {items.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="px-8 font-mono2 text-xs uppercase tracking-[0.35em] text-slate-500">
              {item}
            </span>
            <span className="h-1 w-1 rotate-45 bg-[#F26122]/50" />
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
